"use strict";

exports.__esModule = true;
var _urls = require("./urls");
Object.keys(_urls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _urls[key]) return;
  exports[key] = _urls[key];
});
var _options = require("./options");
Object.keys(_options).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _options[key]) return;
  exports[key] = _options[key];
});